import { render, staticRenderFns } from "./MdReasonDlg.vue?vue&type=template&id=72c8673c&"
import script from "./MdReasonDlg.vue?vue&type=script&lang=js&"
export * from "./MdReasonDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports